import { Component, OnInit, Inject } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Smsbitacora } from 'app/entities/smsbitacora';

@Component({
  selector: 'app-celular-despacho',
  templateUrl: './celular-despacho.component.html',
  styleUrls: ['./celular-despacho.component.scss']
})
export class CelularDespachoComponent implements OnInit {

  public form: Smsbitacora = new Smsbitacora();
  public descripcion;
  public mensaje;
  public numero;
  public descripcion2;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private servicios: ServiciosService, private snack: MatSnackBar) {
  }

  ngOnInit() {
    this.numero = this.datos.numero;
    this.servicios.sms().subscribe((data)=>{
      this.mensaje = data;
    })
  }


  enviarSMS(){
    this.servicios.enviarsms(this.numero, this.descripcion.mensaje1).subscribe((data: any) => {
       if (data.resultado == 0) {
         this.snack.open('Se envio el mensaje con exito', '', {
           duration: 2200,
           panelClass: 'blue-bg'
         })
       } else {
         this.snack.open('Error al enviar el mensaje', '', {
           duration: 2200,
           panelClass: 'warn-bg'
         })
       }
    });
    this.form = {
      TipoSMS: 1,
      Id_MensajePredefinido: this.descripcion.Id_sms,
      MensajeLibre: '',
      numeroCel: this.datos.numero,
      ID_beneficiario: this.datos.beneficiario,
      ID_Titular: this.datos.titular,
      ID_grupo: this.datos.grupo,
      Id_UsuarioQenviaSMS: this.datos.usuario,
      Area: this.descripcion.Area,
      Dependencia: this.descripcion.dependencia,
      Estado: 0,
      Numfactura: null,
      NumCSC: this.datos.csc
    }/* este objeto y esta funcion se encargan de insertar los datos en la bitacora de sms */
    this.servicios.bitacorasms(this.form)
  }

  onValueChange(){
    this.descripcion2 = this.descripcion.mensaje1;
  }
}
